





























































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";
import CategoryTypeSelect from "../general/CategoryTypeSelect.vue";
import SettingsCategoryTypeDetails from "./SettingsCategoryTypeDetails.vue";
import SettingsLocationDetails from "./SettingsLocationDetails.vue";
import SettingsPriceTemplateDetails from "./SettingsPriceTemplateDetails.vue";
import SettingsMaterialItemDetails from "./SettingsMaterialItemDetails.vue";

import { Month, MonthNames } from "../../shared/Month";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import SettingsJson from "../../shared/SettingsJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";
import LocationJson from "../../shared/LocationJson";
import PriceTemplateJson from "../../shared/PriceTemplateJson";
import MaterialItemJson from "../../shared/MaterialItemJson";

import { validateSettingsJson } from "../../shared/SettingsJson";
import { ValidationResult, Validation } from "../../shared/Validation";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

type keysForParseInt = {
  [key in keyof Pick<
    SettingsJson,
    | "deleteUserDataAfterDays"
    | "membershipPaymentDaysAhead"
    | "collectionDateDaysAfterInvoiceDate"
    | "groupBookingCanRequestUntilDaysAhead"
  >]: string;
};

type keysForCachedPrices = {
  [key in keyof Pick<SettingsJson, "membershipDefaultAnnualPrice">]: string;
};

export default Vue.extend({
  name: "SettingsGeneral",
  components: {
    PointerMenu,
    OverlayWindow,
    Loading,
    CategoryTypeSelect,
    SettingsCategoryTypeDetails,
    SettingsLocationDetails,
    SettingsPriceTemplateDetails,
    SettingsMaterialItemDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    userActiveModules: Array as PropType<ModulesJson[]>,
  },
  data() {
    return {
      UserPermissionRank: UserPermissionRank,
      MonthNames: MonthNames,
      CategoryTypeType: CategoryTypeType,
      checkModuleIsActivated: checkModuleIsActivated,
      settingsData: null as SettingsJson | null,
      categoryTypes: null as CategoryTypeJson[] | null,
      allLocations: null as LocationJson[] | null,
      allPriceTemplates: null as PriceTemplateJson[] | null,
      allMaterialItems: null as MaterialItemJson[] | null,
      cachedPrices: {
        membershipDefaultAnnualPrice: "0,00",
      } as keysForCachedPrices,
      reloadCategoryTypes: new Date() as Date,
      showCategoryTypeDetails: false as boolean,
      selectedCategoryTypeId: null as number | null,
      categoryTypeDetailsMode: "read",
      showLocationDetails: false as boolean,
      selectedLocationId: null as number | null,
      locationDetailsMode: "read",
      showPriceTemplateDetails: false as boolean,
      selectedPriceTemplateId: null as number | null,
      priceTemplateDetailsMode: "read",
      showMaterialItemDetails: false as boolean,
      selectedMaterialItemId: null as number | null,
      materialItemDetailsMode: "read",
      toValidate: {} as any,
      validation: null as ValidationResult<SettingsJson> | null,
      hasChanges: false as boolean,
      showHints: {
        timeSlots: false,
      },
      isSaveDataLoading: false,
    };
  },
  created() {
    this.$emit("resetAppFrameButtons");
    this.loadData();
  },
  mounted() {},
  methods: {
    /*** START: details view ***/
    toggleCategoryTypeDetails() {
      this.showCategoryTypeDetails = !this.showCategoryTypeDetails;
      if (this.showCategoryTypeDetails == false) {
        this.reloadCategoryTypes = new Date();
      }
    },

    openCategoryTypeDetails(item: CategoryTypeJson | null, mode: string) {
      if (item != null) {
        this.selectedCategoryTypeId = item.ID;
      } else {
        this.selectedCategoryTypeId = null;
      }

      this.categoryTypeDetailsMode = mode;
      this.toggleCategoryTypeDetails();
    },

    toggleLocationDetails() {
      this.showLocationDetails = !this.showLocationDetails;
      if (this.showLocationDetails == false) {
        this.loadLocations();
      }
    },

    openLocationDetails(item: LocationJson | null, mode: string) {
      if (item != null) {
        this.selectedLocationId = item.ID;
      } else {
        this.selectedLocationId = null;
      }

      this.locationDetailsMode = mode;
      this.toggleLocationDetails();
    },

    togglePriceTemplateDetails() {
      this.showPriceTemplateDetails = !this.showPriceTemplateDetails;
      if (this.showPriceTemplateDetails == false) {
        this.loadPriceTemplates();
      }
    },

    openPriceTemplateDetails(item: PriceTemplateJson | null, mode: string) {
      if (item != null) {
        this.selectedPriceTemplateId = item.ID;
      } else {
        this.selectedPriceTemplateId = null;
      }

      this.priceTemplateDetailsMode = mode;
      this.togglePriceTemplateDetails();
    },

    toggleMaterialItemDetails() {
      this.showMaterialItemDetails = !this.showMaterialItemDetails;
      if (this.showMaterialItemDetails == false) {
        this.loadMaterialItems();
      }
    },

    openMaterialItemDetails(item: MaterialItemJson | null, mode: string) {
      if (item != null) {
        this.selectedMaterialItemId = item.ID;
      } else {
        this.selectedMaterialItemId = null;
      }

      this.materialItemDetailsMode = mode;
      this.toggleMaterialItemDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadSettings();
      this.loadCategoryTypes();
      this.loadLocations();
      this.loadPriceTemplates();
      this.loadMaterialItems();
    },

    async loadSettings() {
      this.settingsData = null;

      try {
        this.settingsData = await this.restClient.getSettings();

        this.$nextTick(() => {
          this.hasChanges = false;
        });
      } catch (e) {
        alert(e.message);
      }

      this.setCachedPrices();
    },

    async loadCategoryTypes() {
      this.categoryTypes = null;

      try {
        this.categoryTypes = await this.restClient.getCategoryTypes();

        this.$nextTick(() => {
          this.hasChanges = false;
        });
      } catch (e) {
        alert(e.message);
      }
    },

    async loadLocations() {
      if (this.restClient != null) {
        this.allLocations = null;

        try {
          this.allLocations = await this.restClient.getLocations();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadPriceTemplates() {
      if (this.restClient != null) {
        this.allPriceTemplates = null;

        try {
          this.allPriceTemplates = await this.restClient.getPriceTemplates();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadMaterialItems() {
      if (this.restClient != null) {
        this.allMaterialItems = null;

        try {
          this.allMaterialItems = await this.restClient.getMaterialItems();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async saveAppSettings() {
      if (this.settingsData != null) {
        this.validation = validateSettingsJson(this.settingsData);

        if (this.validation != null && this.validation.isValid == true) {
          this.isSaveDataLoading = true;

          try {
            this.settingsData = await this.restClient.saveSettings(this.settingsData);

            this.$emit("reloadSettings");

            this.$nextTick(() => {
              this.hasChanges = false;
            });
          } catch (e) {
            alert("Speichern fehlgeschlagen: " + e.message);
          }

          this.isSaveDataLoading = false;
        } else {
          alert("Die Daten konnten nicht gespeichert werden. Bitte prüfen Sie Ihre Angaben.");
        }
      }
    },

    discardChanges() {
      this.toValidate = {};
      this.loadSettings();
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.settingsData != null) {
        this.validation = validateSettingsJson(this.settingsData);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    /*** START control cached data ***/

    /* set cached data */

    setCachedPrices() {
      if (this.settingsData != null) {
        let k = this.cachedPrices;
        let i: keyof typeof k;

        for (i in this.cachedPrices) {
          let price = this.getFormatPrice(this.settingsData[i]);

          this.cachedPrices[i] = price;
        }
      }
    },

    /* format and set data where be cached */

    formatAndSetCachedPrices(key: keyof keysForCachedPrices) {
      if (this.settingsData != null) {
        let price = this.cachedPrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[key] = price;
        this.settingsData[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    /*** END control cached data ***/

    parseNumberInputs(input: keyof keysForParseInt) {
      if (this.settingsData != null) {
        this.settingsData[input] = +this.settingsData[input];
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    settingsData: {
      deep: true,
      handler() {
        this.hasChanges = true;
      },
    },

    hasChanges: {
      deep: true,
      handler() {
        this.$emit("changesInChild", this.hasChanges);
      },
    },
  },
  computed: {},
});
